import {
  createQRTransferProfile,
  QR_VERSION_OPTIONS,
  ECC_LEVEL_OPTIONS,
  type QRTransferProfile,
} from '@qwerty/engine/protocol/profiles';
import type { EccLevel } from '@qwerty/engine/qr/qr_encode';

export const QR_VERSIONS = QR_VERSION_OPTIONS;
export const ECC_LEVELS = ECC_LEVEL_OPTIONS;

export function eccIndex(ecc: EccLevel): number {
  switch (ecc) {
    case 'L': return 0;
    case 'M': return 1;
    case 'Q': return 2;
    default: return 3;
  }
}

export function profileFor(version: number, ecc: EccLevel): QRTransferProfile {
  return createQRTransferProfile(version, ecc);
}

export interface ParallelLayout { columns: number; rows: number; }

export function layoutFor(parallelCount: number): ParallelLayout {
  switch (parallelCount) {
    case 1: return { columns: 1, rows: 1 };
    case 2: return { columns: 2, rows: 1 };
    case 6: return { columns: 3, rows: 2 };
    case 8: return { columns: 4, rows: 2 };
    default: return { columns: 2, rows: 2 };
  }
}
